exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heading-style{color:#292f4c!important}.faq-section .mb-0>a{display:block;position:relative}.faq-section .mb-0>a:after{content:\"\\F067\";font-family:Font Awesome\\ 5 Free;position:absolute;right:0;font-weight:600}.faq-section .mb-0>a[aria-expanded=true]:after{content:\"\\F068\";font-family:Font Awesome\\ 5 Free;font-weight:600}", ""]);

// exports
